var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _vm.label ? _c("label", [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(),
    _c("div", { staticClass: "input-container" }, [
      _c(
        "input",
        _vm._b(
          {
            ref: "file",
            attrs: { type: "file", accept: _vm.accept, multiple: _vm.multiple },
            on: { change: _vm.onChangeFile },
          },
          "input",
          _vm.$attrs,
          false
        )
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }